module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/e55f58ca0fc97b7b5c1527677f44c981.png";